<ng-content></ng-content>
<fa-icon class="status" *ngIf="isSortedByMe"
  [icon]="isSortedByMeDesc ? 'caret-down' : 'caret-up'">
</fa-icon>
<fa-icon class="intent" *ngIf="isSortedByMe"
  [icon]="isSortedByMeDesc ? 'caret-up' : 'caret-down'">
</fa-icon>
